import React from 'react';

const CompanyEmail = () => {
  return <a href="mailto:team@gear2go.us">team@gear2go.us</a>;
};

export default CompanyEmail;
